import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { APIFactoryEndPoints } from '../common/apifactory-end-points';
import { CommonService } from '../service/Security/common.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isAuthenticated: boolean;

  constructor(
    private commonService: CommonService,
    private apiUrl: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,

   
    ) {
  }

  async ngOnInit() {
    // this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    // // Subscribe to authentication state changes
    // this.oktaAuth.$authenticationState.subscribe(
    //   (isAuthenticated: boolean)  => this.isAuthenticated = isAuthenticated
    // );
  }
  onLogOutClick()
  {
    // this.commonService.removeFCMRegistrationData(this.apiUrl.removeTokenByToken, this.persistenceService.get('FirebaseToken')).subscribe((data: any) => {
    // });
   // this.oktaAuth.logout();
  }
}
